.CheckboxContainer {
  display: inline-block;
  width: 14px;
  height: 14px;
  vertical-align: middle;
  position: relative;

  .HiddenCheckbox {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 0;
    opacity: 0;
    cursor: pointer;
  }

  .svgContainer {
    width: 9.216px;
    height: 6.84px;
  }

  .StyledCheckbox {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    @include themify($themes) {
      border: 1px solid themed("neutral-secondary");
      background-color: themed("background");
    }

    &.checked {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;

      @include themify($themes) {
        background-color: themed("checkbox_check_background");
      }
    }

    &.disabled {
      opacity: 0.3;
    }
  }

  &.large {
    width: 20px;
    height: 20px;

    .StyledCheckbox {
      border-radius: 6px;
    }
  }
}
